import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Notification from '@/components/Notification'
import { senderToken } from '@/store'
import { useWeb3React } from '@/hooks/useWeb3React'
import { getTokenAmount, isMainAddress } from '@/utils'
import { formatEther, formatUnits } from 'viem'

const useSenderTokenAmount = () => {
  const { account, chainId, provider } = useWeb3React()

  const [tokenAmount, setTokenAmount] = useState(0)
  const { address, decimals } = useSelector(senderToken)
  useEffect(() => {
    if (address && chainId) getAmountHandler(address)
  }, [address, account, chainId])

  const getAmountHandler = async (address: string) => {
    try {
      if (isMainAddress(address)) {
        const balance_ = await provider.getBalance({ address: account })
        const _balance = parseFloat(formatEther(balance_)).toFixed(3)
        setTokenAmount(Number(_balance))
      } else {
        const res: any = await getTokenAmount(account, address, provider)
        const _amount = formatUnits(res, Number(decimals))
        const amount_ = Number(Number(_amount).toFixed(5))
        setTokenAmount(amount_)
      }
    } catch (error) {
      Notification.Error('代币余额获取错误')
      setTokenAmount(0)
    }
  }

  return tokenAmount
}

export default useSenderTokenAmount
